
define('eteration/widgets/ui-cms',[ 'knockout','eteration/eteration-ajax','eteration/eteration-i18n','jstorage'], function(ko,etrAjax,i18n) {

		var language= i18n.getUserLocale();
		var country =i18n.getUserCountry();
    ko.bindingHandlers.cms = {
	    update: function(element, valueAccessor, allBindingsAccessor, viewModel) {

            execute(getItem(element,valueAccessor));
  	    }
    };

    var ongoingRequests = { };
    var i;

    function getItem(element,valueAccessor) {
        var item = {};
        item.schema = ko.unwrap(valueAccessor().schema);
        item.template = ko.unwrap(valueAccessor().template);
        item.maxItems = ko.unwrap(valueAccessor().maxItems);
        item.keyword = ko.unwrap(valueAccessor().keyword);
        item.metadata = ko.unwrap(valueAccessor().metadata);
        item.params = ko.unwrap(valueAccessor().params);
        item.callback = ko.unwrap(valueAccessor().callback);
        item.cacheResponse = ko.unwrap(valueAccessor().cache) || false;
        item.element = element;
        var pass = {
            'schema': item.schema,
            'template': item.template,
            'maxItems': item.maxItems,
			'language':language,
			'country':country
        };
        if(item.keyword){
            pass.keyword = item.keyword;
        }
        if(item.metadata){
            pass.metadata = item.metadata;
        }
        item.hash = window.hashCode("cms:"+JSON.stringify(pass));
        item.pass = pass;
        return item;
    }
    
    function execute(item) {
        var cachedResponse = null;
        if(item.cacheResponse && $.jStorage){
            cachedResponse = $.jStorage.get(item.hash);
            if(cachedResponse)
                renderResponse(item,cachedResponse);

        }

        if(!cachedResponse){

            if(ongoingRequests[item.hash]&&ongoingRequests[item.hash].length>0){
                ongoingRequests[item.hash].push(item);
                return;
            }
            if(!(item.keyword||item.metadata)){
                return;
            }

            ongoingRequests[item.hash]=ongoingRequests[item.hash] || [];
            ongoingRequests[item.hash].push(item);

            var callback = function(response) {
                if(response.data){

                    if(item.cacheResponse){
                        if($.jStorage){
                            $.jStorage.set(item.hash, response, {TTL: 3600000});
                        }
                    }

                    for(i = 0;i<ongoingRequests[item.hash].length;i++){
                        renderResponse(ongoingRequests[item.hash][i],response);
                    }
                    delete ongoingRequests[item.hash];
                }
            }
            runCMSQuery(item,callback)
        }
    }

    function runCMSQuery(item,cb) {
        var  cmsQuery ={
            app : 'app.cms',
            service : '/content/query' ,
            data:item.pass,
            disableLoader:true,
            disableErrorHandling:true,
            global:false,
            callback:cb
        };
        etrAjax.post(cmsQuery);
    }

    function renderResponse(item,response) {
        var mydiv =  $(item.element);
        var allHTML = "";
        if(mydiv){
            mydiv.html("");
            var tridionContent = "";
            tridionContent = response.data.components || [];
            for(i=0; i < tridionContent.length; i++){
                allHTML += tridionContent[i].html

            }

            if(item.params){
                for(var i=0; i < item.params.length; i++){
                    var param = item.params[i];
                    allHTML = allHTML.replace('{.'+param.key+'}',param.value);
                }
            }
            mydiv.html(allHTML);
            if(item.callback){
                item.callback();
            }
            $('.mobile-tooltip').on("click",function(e){
                e.preventDefault();
                $("img").tooltip();

            });
            carouselIndicators();
        }
    }

    function getContent(element, valueAccessor){
	       var schema = ko.unwrap(valueAccessor().schema);
	       var template = ko.unwrap(valueAccessor().template);
	       var maxItems = ko.unwrap(valueAccessor().maxItems);
	       var keyword = ko.unwrap(valueAccessor().keyword);
	       var metadata = ko.unwrap(valueAccessor().metadata);
	       var params = ko.unwrap(valueAccessor().params);
	       var callback = ko.unwrap(valueAccessor().callback);
	       var cacheResponse = ko.unwrap(valueAccessor().cache) || false;
	       var pass, key, cachedResponse, renderResponse;
	       
	       if(metadata == undefined){
	    	   pass = {
	    			   'schema': schema,
	    			   'template': template, 
	    			   'maxItems': maxItems,
	    			   'keyword': keyword,
						'language':language,
						'country':country
	    	   };

	    	   renderResponse = function(response) {
	    		   var mydiv =  $(element);
	    		   var allHTML = "";
	    		   if(mydiv){
	    			   mydiv.html("");
	    			   var tridionContent = "";
	    			   tridionContent = response.data.components || [];
	    			   for(i=0; i < tridionContent.length; i++){
	    				   allHTML += tridionContent[i].html

	    			   }

	    			   if(params){
	    				   for(i=0; i < params.length; i++){
	    					   var param = params[i];
	    					   allHTML = allHTML.replace('{.'+param.key+'}',param.value);
	    				   }
	    			   }
	    			   mydiv.html(allHTML); 
	    			   if(callback){
	    				   callback();
	    			   }
	    			   $('.mobile-tooltip').on("click",function(e){
	    				   e.preventDefault();
	    				   $("img").tooltip();

	    			   });
	    			   carouselIndicators();
	    		   }   
	    	   };

	    	   key = window.hashCode("cms:"+JSON.stringify(pass));

	    	   cachedResponse = null;
	    	   if(cacheResponse && $.jStorage){
	    		   cachedResponse = $.jStorage.get(key);
	    		   if(cachedResponse)
	    			   renderResponse(cachedResponse);

	    	   }

	    	   if(!cachedResponse){

	    		   var  cmsQuery ={
	    				   app : 'app.cms',
	    				   service : '/content/query' ,
	    				   data:pass,
	    				   disableLoader:true,
	    				   disableErrorHandling:true, 
	    				   global:false,
	    				   callback:function(response) {
	    					   if(response.data){
	    						   if(cacheResponse){
	    							   if($.jStorage){
	    								   $.jStorage.set(key, response, {TTL: 3600000});
	    							   }
	    						   }
	    						   renderResponse(response);
	    					   }
	    				   }
	    		   };

	    		   if(keyword && keyword.length) {
	    			   etrAjax.post(cmsQuery);
	    		   }
	    	   }
	       }
	       else if(keyword == undefined) {
	    	   pass = {
	    			   'schema': schema,
	    			   'template': template, 
	    			   'maxItems': maxItems,
	    			   'metadata': metadata,
						'language':language,
						'country':country
	    	   };

	    	   renderResponse = function(response) {
	    		   var mydiv =  $(element);
	    		   var allHTML = "";
	    		   if(mydiv){
	    			   mydiv.html("");
	    			   var tridionContent = "";
	    			   tridionContent = response.data.components || [];
	    			   for(i=0; i < tridionContent.length; i++){
	    				   allHTML += tridionContent[i].html

	    			   }

	    			   if(params){
	    				   for(i=0; i < params.length; i++){
	    					   var param = params[i];
	    					   allHTML = allHTML.replace('{.'+param.key+'}',param.value);
	    				   }
	    			   }
	    			   mydiv.html(allHTML); 
	    			   if(callback){
	    				   callback();
	    			   }
	    			   $('.mobile-tooltip').on("click",function(e){
	    				   e.preventDefault();
	    				   $("img").tooltip();

	    			   });
	    			   carouselIndicators();
	    		   }   
	    	   };

	    	   key = window.hashCode("cms-meta:"+JSON.stringify(pass));

	    	   cachedResponse = null;
	    	   if(cacheResponse && $.jStorage){
	    		   cachedResponse = $.jStorage.get(key);
	    		   if(cachedResponse)
	    			   renderResponse(cachedResponse);
	    	   }

	    	   if(!cachedResponse) {
	    		   var  cmsQuerywithmetadata ={
	    				   app : 'app.cms',
	    				   service : '/content/query' ,
	    				   data:pass,
	    				   disableLoader:true,
	    				   disableErrorHandling:true, 
	    				   global:false,
	    				   callback:function(response) {
	    					   if(response.data){
	    						   if(cacheResponse){
	    							   if($.jStorage){
	    								   $.jStorage.set(key, response, {TTL: 3600000});
	    							   }
	    						   }
	    						   renderResponse(response);
	    					   }
	    				   }
	    		   };

	    		   if(metadata && metadata.length) {
	    			   etrAjax.post(cmsQuerywithmetadata);
	    		   }
	    	   }
	       }
    }
	
});
